/* T26: Highlights the Home step in the middle of the viewport and keeps the bar below the header.
   Anchor links and the CSS --header-end fallback work without this script. */
if (!customElements.get('t26-home-stepper')) {
  class T26HomeStepper extends HTMLElement {
    connectedCallback() {
      this.trackHeader();
      this.links = [...this.querySelectorAll('.t26-home-stepper__link')];
      const pairs = this.links
        .map((link) => [link, document.getElementById(decodeURIComponent(link.hash.slice(1)))])
        .filter(([, target]) => target);
      if (!pairs.length) return;

      this.linkByTarget = new Map(pairs.map(([link, target]) => [target, link]));
      this.setActive(pairs[0][0]);
      this.observer = new IntersectionObserver((entries) => {
        const visible = entries.find((entry) => entry.isIntersecting);
        if (visible) this.setActive(this.linkByTarget.get(visible.target));
      }, { rootMargin: '-40% 0px -55% 0px' });
      pairs.forEach(([, target]) => this.observer.observe(target));
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      this.observer = null;
      if (!this.header) return;
      window.removeEventListener('scroll', this.onScroll);
      this.resizeObserver.disconnect();
      this.classObserver.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.header = null;
    }

    /* T26: --header-end is refreshed 300ms after the header shows or hides (and is stale on
       mobile), so follow the header's live bottom edge. The header animates after scrolling
       stops, sometimes without a class change, so keep following briefly after each scroll. */
    trackHeader() {
      this.header = document.querySelector('store-header');
      if (!this.header) return;
      this.queueSync = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.syncTop(); });
      };
      this.followUntil = 0;
      this.onScroll = () => {
        this.followUntil = performance.now() + 600;
        this.queueSync();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.queueSync);
      this.resizeObserver.observe(this.header);
      this.classObserver = new MutationObserver(() => {
        this.followUntil = performance.now() + 600;
        this.queueSync();
      });
      this.classObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
      this.syncTop();
    }

    syncTop() {
      if (!this.header) return;
      const bottom = Math.max(0, this.header.getBoundingClientRect().bottom);
      this.style.setProperty('--t26-stepper-top', `${bottom.toFixed(1)}px`);
      if (performance.now() < this.followUntil) this.queueSync();
    }

    setActive(activeLink) {
      this.links.forEach((link) => {
        const active = link === activeLink;
        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'step');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }
  }

  customElements.define('t26-home-stepper', T26HomeStepper);
}
